import Moment from 'moment'

/***
 * Vue mixin used in both the team booking modal & courtesy car reservation modal.
 */

export default {
    data() {
        return {
            modelName: '', // e.g. booking, reservation, instance, etc
            disableCustomerWaitingDurationOption: false
        }
    },
    methods: {
            dateSelectorString(from, to) {
                return Math.ceil(to.diff(from, 'days', true)) + ' days (' + to.format('ddd D') + ')'
            },
    },
    computed: {
        durationOptions() {
            let options = []

            if (!this.disableCustomerWaitingDurationOption) {
                options.push({ label: 'Customer Waiting', value: 0})
            }

            let date = (new Moment(this.calendarEntry.from)).endOf('day');

            for (let i = 1; i <= 30; i++) {
                options.push({
                    label: this.dateSelectorString(this.calendarEntry.from, date),
                    value: new Moment(date)
                })

                date.add(1, 'days')
            }

            return options
        },
        timeOptions() {
            let maxHour = 20
            let minHour = 6
            let intervalMinutes = 30
            let times = [{ label: 'Anytime', value: { hours: 0, minutes: 0 }}]
            let time = new Moment('2019-06-12 ' + minHour + ':00', 'YYYY-MM-DD k:mm')

            while (time.hour() <= maxHour) {
                times.push({
                    label: time.format('H:mma'),
                    value: { hours: time.hour(), minutes: time.minutes() }
                })

                time.add(intervalMinutes, 'minutes')
            }

            return times
        },
        dateProxy: {
            get() {
                if (this.calendarEntry.from) {
                    return this.calendarEntry.from.toDate()
                }
            },
            set(value) {
                let existingDuration = this.toProxy ? this.toProxy.days : 0
                let defaultStartTime = false

                if (!this.calendarEntry.from) {
                    defaultStartTime = true
                }

                let date = new Moment(value)

                if (defaultStartTime) {
                    date = date.startOf('day')
                }

                this.calendarEntry.from = date

                if (!this.calendarEntry.to || 0 === existingDuration) {
                    date = new Moment(date)
                    date.endOf('day')
                    this.calendarEntry.to = date
                } else if (existingDuration > 0) {
                    date = new Moment(this.calendarEntry.from)
                    date = date.add(existingDuration - 1, 'days').endOf('day')
                    this.calendarEntry.to = date
                }
            }
        },
        toProxy: {
            get() {
                if (this.calendarEntry.to && this.calendarEntry.from) {
                    let diff = Moment(this.calendarEntry.to).diff(this.calendarEntry.from, 'days', true)
                    if (0 === diff) {
                        return {
                            label: 'Customer Waiting',
                            days: 0,
                            value: 0,
                        }
                    }

                    return {
                        label: this.dateSelectorString(this.calendarEntry.from, Moment(this.calendarEntry.to)),
                        days: diff,
                        value: this.calendarEntry.to
                    }
                }
            },
            set(value) {
                let date = new Moment(this.calendarEntry.from)

                if (0 !== value.value) {
                    date = new Moment(value.value)
                    date = date.endOf('day')
                }

                this.calendarEntry.to = date
            }
        },
        timeProxy: {
            get() {
                if (this.calendarEntry.from) {
                    if (0 === this.calendarEntry.from.hour() && 0 === this.calendarEntry.from.minute()) {
                        return {
                            label: 'Anytime',
                            value: {
                                hours: 0,
                                minutes: 0
                            }
                        }
                    }

                    return {
                            label: this.calendarEntry.from.format('H:mma'),
                            value: {
                                hours: this.calendarEntry.from.hour(),
                                minutes: this.calendarEntry.from.minutes()
                            }
                        }
                }

                return ''
            },
            set(value) {
                if (value.value) {
                    let isCustomerWaiting = (this.toProxy.value === 0);

                    let from = new Moment(this.calendarEntry.from)
                    from = from.hour(value.value.hours)
                    from = from.minutes(value.value.minutes)
                    from = from.seconds(0)
                    this.calendarEntry.from = from

                    if (!isCustomerWaiting) {
                        let to = new Moment(this.calendarEntry.to)

                        to = Moment(to).endOf('day');
                        this.calendarEntry.to = to
                    } else {
                        this.calendarEntry.to = from
                    }
                }
            }
        },
        bookingDurationDays() {
            return Math.ceil(Moment(this.calendarEntry.to).diff(this.calendarEntry.from, 'days', true))
        },
        instanceProxy: {
            get() {
                if (this[this.modelName] && this[this.modelName].instance && this[this.modelName].instance.id) {
                    return this[this.modelName].instance
                }

                return {}
            },
            set(value) {
                this[this.modelName].instance = value
                this.$set(this[this.modelName], 'instance', value)
                this[this.modelName].instance_id = value.id

                if (!this[this.modelName].contact && value.owner) {
                    this.customerProxy = value.owner
                }
            }
        },
        customerProxy: {
            get() {
                if (this[this.modelName] && this[this.modelName].contact) {
                    return this[this.modelName].contact
                }

                return {}
            },
            set(value) {
                this.$set(this[this.modelName], 'contact', value)
                this[this.modelName].contact = value
                this[this.modelName].contact_id = value.id
            }
        },
    }
}